<template>
    <div>
        <!-- confirm modal -->
        <b-modal
            :id="modalId"
            @hidden="onModalHidden()"
            modal-class="modal-confirm"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div v-if="!hideClose" class="modal-base-close" @click="hide()">
                <img src="@/assets/profile/close-new.svg" alt="" />
            </div>
            <div class="modal-base">
                <div class="modal-base-head">
                    <p v-html="title"></p>
                </div>
                <div class="modal-base-body" v-html="message"></div>
                <div v-if="buttonStyle" class="modal-base-footer">
                    <div class="button brown-btn" @click="clickOk()">
                        {{ btnOk }}
                    </div>
                    <div
                        class="button underline-black-btn"
                        @click="clickCancel()"
                    >
                        {{ btnCancel }}
                    </div>
                </div>
                <div v-else class="modal-base-footer">
                    <div class="button brown-btn" @click="clickCancel()">
                        {{ btnCancel }}
                    </div>
                    <div class="button underline-black-btn" @click="clickOk()">
                        {{ btnOk }}
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "ConfirmModal",
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String,
    },
    data: function () {
        return {
            title: "",
            message: "",
            btnOk: "",
            btnCancel: "",
            tag: "",
            params: {},
            hideClose: false,
            userCallback: false,
            buttonStyle: false,
            busModal: null,
            lbl: Locale.getLbl(),
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    watch: {
        params(newVal, oldVal) {
            if (newVal != oldVal) {
                if (this.params.active === "all") {
                    this.message = this.messageAll;
                }
            }
        },
        hideClose(newVal, oldVal) {
            if (newVal != oldVal) {
                this.hideClose = newVal;
            }
        },
        userCallback(newVal, oldVal) {
            if (newVal != oldVal) {
                this.userCallback = newVal;
            }
        },
        buttonStyle(newVal, oldVal) {
            if (newVal != oldVal) {
                this.buttonStyle = newVal;
            }
        },
    },
    methods: {
        onModalHidden: function () {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function () {
            this.hide();
            if (this.userCallback) {
                this.controller.sendCallbackOk();
            } else {
                this.controller.sendCancelRequest(this.params);
            }
        },
        clickCancel: function () {
            this.hide();
            // this.controller.sendCallbackCancel({ tag: this.tag });
        },
        show: function (config) {
            this.title = config.title;
            this.messageAll = config.msgAll;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;
            this.tag = config.tag;
            this.params = config.params;
            this.hideClose = config.hideClose;
            this.buttonStyle = config.buttonStyle;
            this.userCallback = config.userCallback;
            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            if (Util.isEmptyStr(config.btnCancel)) {
                this.btnCancel = this.lbl.default.cancel;
            }
            this.$bvModal.show(this.modalId);
        },
        hide: function () {
            this.$bvModal.hide(this.modalId);
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/style/modal.scss";
@import "@/module/Order/style/orderStyle.scss";
.modal-confirm {
    .modal-base {
        .modal-base-body {
            text-align: center;
        }
    }
}
</style>
